import moment from 'moment-timezone';

export const getFormattedDateInTz = (date: string, tz: string, format: string) => {
  return moment(date).tz(tz).format(format);
};
